// extracted by mini-css-extract-plugin
module.exports = {"footer__ref":"footerText_footer__ref__ketaG"};